/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ACHProcessorEnum {
    NONE = 'None',
    TTECH = 'TTech',
    PACE_EVEREST = 'Pace_Everest',
    PACE_TRANSAFE = 'Pace_Transafe',
    THIRD_PARTY = 'Third_Party',
    I3PAY_FAC = 'i3PayFac',
}